import { ReactElement } from 'react';

import { ModalContextModel } from '../../../../components/modal/models/modal-context.model';

export const openModalWithDialogComponent =
  (dialog: ReactElement, ctx: ModalContextModel): (() => void) =>
  () => {
    ctx.componentHandler(dialog);
    ctx.modalStateHandler();
  };
